import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from '@atoms/Button';
import { Input } from '@atoms/Input';
import { Card } from '@atoms/Card';
import { reviewService } from '@services/reviewService';
import type { Order } from '@/types';

interface ReviewFormProps {
  order: Order;
  onDone: () => void;
}

export function ReviewForm({ order, onDone }: ReviewFormProps) {
  const queryClient = useQueryClient();
  const [ratingSpeed, setRatingSpeed] = useState(5);
  const [ratingQuality, setRatingQuality] = useState(5);
  const [ratingFlavor, setRatingFlavor] = useState(5);
  const [comment, setComment] = useState('');

  const submitMutation = useMutation({
    mutationFn: () =>
      reviewService.submit({
        orderId: order.id,
        ratingSpeed,
        ratingQuality,
        ratingFlavor,
        comment: comment || undefined,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['restaurant', 'orders'] });
      onDone();
    },
  });

  const RatingSelect = ({
    label,
    value,
    onChange,
  }: {
    label: string;
    value: number;
    onChange: (v: number) => void;
  }) => (
    <div>
      <label className="mb-1 block text-sm font-medium">{label}</label>
      <select
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {[5, 4, 3, 2, 1].map((n) => (
          <option key={n} value={n}>
            {n} yıldız
          </option>
        ))}
      </select>
    </div>
  );

  return (
    <Card className="mt-3 border-t pt-3">
      <p className="mb-3 text-sm font-medium">Siparişi Değerlendir</p>
      <div className="grid gap-3 md:grid-cols-3">
        <RatingSelect label="Hız" value={ratingSpeed} onChange={setRatingSpeed} />
        <RatingSelect label="Kalite" value={ratingQuality} onChange={setRatingQuality} />
        <RatingSelect label="Lezzet" value={ratingFlavor} onChange={setRatingFlavor} />
      </div>
      <Input
        className="mt-3"
        label="Yorum (isteğe bağlı)"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Deneyiminizi paylaşın..."
      />
      <div className="mt-3 flex gap-2">
        <Button loading={submitMutation.isPending} onClick={() => submitMutation.mutate()}>
          Gönder
        </Button>
        <Button variant="secondary" onClick={onDone}>
          Vazgeç
        </Button>
      </div>
    </Card>
  );
}
